import TreeMap from './echarts/TreeMap'
import RingChart from './echarts/Ring'
import ChartProvider from './echarts/ChartProvider'
import AxisX from './echarts/AxisX'
import AxisY from './echarts/AxisY'
import Tooltip from './echarts/Tooltip'
import ColorProvider from './echarts/ColorProvider'
import InlineChart from './echarts/InlineChart'

const abundanceEngineExports = {
  ChartTreeMap: TreeMap,
  RingChart,
  ChartProvider,
  ChartAxisX: AxisX,
  ChartAxisY: AxisY,
  ChartTooltip: Tooltip,
  ChartColorProvider: ColorProvider,
  InlineChart
}

export default abundanceEngineExports
